import { getConfiguration } from "./configuration";

export function startPrefetch(): void {
	setTimeout(() => {
		if (window.requestIdleCallback === undefined) {
			doStartPrefetch();
		} else {
			window.requestIdleCallback(doStartPrefetch);
		}
	}, 10 * 1000);
}

function doStartPrefetch(): void {
	const scripts = getConfiguration().prefetch;

	for (let script of scripts) {
		createPrefetch(script);
	}
}

function createPrefetch(script: string): void {
	const link = document.createElement("link");
	link.rel = "prefetch";
	link.href = script;
	(link as any).fetchpriority = "low";

	document.head.appendChild(link);
}
